import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APICommonService } from '@nationwide/internet-servicing-angular-services';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LANDING_PAGES } from '../../CONSTANTS/tpi-common-constants';
import { UserInfoRequest } from '../../tpi-models/login-logout/user-info';
import { SessionService } from '../tpi-session/session.service';

@Injectable({
    providedIn: 'root'
})
export class LoginLogoutService {
    private apiCommonService = inject(APICommonService);
    private httpClient = inject(HttpClient);
    private oidcSecurityService = inject(OidcSecurityService);
    private router = inject(Router);
    private sessionService = inject(SessionService);

    getHttpOptions(euaToken: string): HttpHeaders {
        return this.apiCommonService.buildHeader({
            appClientId: environment.authorize.client_id,
            authToken: euaToken,
            nwAppId: '',
            contentType: 'application/json',
            headerType: 'X-NW-MessageID'
        });
    }

    getUserInfo(userInfoRequest: UserInfoRequest): Observable<any> {
        const euaToken = sessionStorage.getItem('jwt');
        const headers = this.getHttpOptions(euaToken);
        return this.httpClient.post(`${environment.APIs.apigeeEnvironment}${environment.APIs.userInfo}?showDetails=true`, userInfoRequest, { headers });
    }

    login(): void {
        this.oidcSecurityService.authorize();
    }

    logout(destination: string = LANDING_PAGES.LOGOUT): void {
        this.sessionService.isLoggedIn = false;
        this.router.navigate([destination]);
    }
}